module.exports = __webpack_public_path__ + "static/img/bottom2.7422464f.jpg";